"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageWithCaption = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const front_1 = require("../../../dsl/front");
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let ImageWithCaption = class ImageWithCaption extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.size = front_1.SizeMap;
    }
    /**
     * Shorthand for `this.image.author` with some additional security checks.
     */
    get author() {
        if (this.hideAuthor) {
            return;
        }
        if (this.image === null ||
            typeof this.image.author !== 'string' ||
            this.image.author.length === 0) {
            return;
        }
        return this.image.author;
    }
    /**
     * Shorthand for `this.image.caption` with some additional security checks.
     */
    get caption() {
        if (this.overridenCaption !== undefined) {
            return this.overridenCaption;
        }
        if (this.hideDescription) {
            return;
        }
        if (this.image === null ||
            typeof this.image.caption !== 'string' ||
            this.image.caption.length === 0) {
            return;
        }
        return this.image.caption;
    }
    /**
     * Emits click event on figure
     */
    onImageClick() {
        this.$emit('click');
    }
};
__decorate([
    vue_property_decorator_1.Prop({
        type: Boolean,
        required: false,
        default: false
    }),
    __metadata("design:type", Boolean)
], ImageWithCaption.prototype, "canPreview", void 0);
__decorate([
    vue_property_decorator_1.Prop({
        type: Boolean,
        required: false,
        default: false
    }),
    __metadata("design:type", Boolean)
], ImageWithCaption.prototype, "hideAuthor", void 0);
__decorate([
    vue_property_decorator_1.Prop({
        type: Boolean,
        required: false,
        default: false
    }),
    __metadata("design:type", Boolean)
], ImageWithCaption.prototype, "hideDescription", void 0);
__decorate([
    vue_property_decorator_1.Prop({
        type: Object,
        required: false,
        default: null
    }),
    __metadata("design:type", Object)
], ImageWithCaption.prototype, "image", void 0);
__decorate([
    vue_property_decorator_1.Prop({
        type: Boolean,
        required: false,
        default: false
    }),
    __metadata("design:type", Boolean)
], ImageWithCaption.prototype, "isLazy", void 0);
__decorate([
    vue_property_decorator_1.Prop({
        type: Boolean,
        required: false,
        default: false
    }),
    __metadata("design:type", Boolean)
], ImageWithCaption.prototype, "fetchPriority", void 0);
__decorate([
    vue_property_decorator_1.Prop({
        type: String,
        required: false
    }),
    __metadata("design:type", String)
], ImageWithCaption.prototype, "overridenCaption", void 0);
ImageWithCaption = __decorate([
    vue_property_decorator_1.Component({
        name: 'ImageWithCaption',
        components: {
            BootstrapImage: front_1.BootstrapImage,
            BootstrapIcon: front_1.BootstrapIcon
        },
        template: `
    <figure v-if="image" class="image-with-caption" @click="onImageClick">

    <!-- Image itself -->
    <div :class="{'preview-image-container' : canPreview}">
      <div class="image-with-caption__image-wrapper">
        <BootstrapImage
          v-bind="{ ...image, isLazy, fullscreen:null, alt:(image.alt)?image.alt:image.caption, caption:null, fetchpriority:(fetchPriority)?'high':null }"
          class="image-with-caption__image"/>
        <slot/>
      </div>
      <BootstrapIcon v-if="canPreview" class="preview-image-icon" :size="size.Large" :name="'search'"/>
    </div>

    <figcaption v-if="caption || author" class="image-with-caption__caption">
      <!-- Caption -->
      <template v-if="caption">
        {{ caption }}
      </template>

      <!-- Author -->
      <cite v-if="author">
        <br v-if="caption"/>
        {{ $t('_.photo-by') }}. {{ author }}
      </cite>
    </figcaption>
    </figure>
  `
    })
], ImageWithCaption);
exports.ImageWithCaption = ImageWithCaption;
//# sourceMappingURL=ImageWithCaption.js.map